<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>{{$route.query.id != null ? 'Editar' : 'Crear'}} usuario</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form ref="form" class="mt-3">
                        <v-row justify="end">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        dense
                                        to="lista-usuario"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-row>

                        <datos-personales
                            v-model="usuario"
                            ref="form"
                        ></datos-personales>

                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-usuario">
                                    <v-btn
                                        color="red"
                                        class="white--text mr-2"
                                        s
                                    >
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <template v-if="usuario.idRol == 5">
                                    <v-btn
                                        v-if="!usuario.id"
                                        @click="saveagente"
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text mr-2"
                                        >Guardar</v-btn
                                    >
                                </template>
                                <template v-else>
                                    <v-btn
                                        v-if="!usuario.id"
                                        @click="saveusuario"
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text mr-2"
                                        >Guardar</v-btn
                                    >
                                </template>
                                <v-btn
                                    v-if="usuario.id"
                                    @click="updateusuario"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="usuario.id"
                                    @click="dialog_delete = true"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
        <DeleteDialog
            v-model="dialog_delete"
            @delete="deleteusuario"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
import DatosPersonales from "./DatosPersonales.vue";
import { formatPrice } from "../../../helpers";
export default {
    data() {
        return {
            dialog_delete: false,
            menu: false,
            usuario: {
                id: null,
                email: "",
                idRol: null,
                name: "",
                hora_coste: 0,
                hora_extra_coste: 0,
            },
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
        };
    },
    watch: {
        usuario: {
            deep: true,
            handler() {
                //console.log(this.usuario);
            },
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        if (this.$route.query.id) {
            this.getusuario(this.$route.query.id);
        }
    },
    methods: {
        // Acciones de usuario
        getusuario(usuario_id) {
            axios.get(`api/getusuario/${usuario_id}`).then(
                (res) => {
                    this.usuario = res.data;
                    this.usuario.hora_coste = formatPrice(
                        this.usuario.hora_coste
                    );
                    this.usuario.hora_extra_coste = formatPrice(
                        this.usuario.hora_extra_coste
                    );
                },
                (res) => {}
            );
        },
        saveusuario() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            axios
                .post("api/save-usuario", this.usuario)
                .then((res) => {
                    if (res.data.status == 200) {
                        this.$router.push("lista-usuario");
                    } else {
                        this.$toast.warn(res.data.message);
                        setTimeout(() => {
                            this.$router.push("lista-usuario");
                        }, 3000);
                    }
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        updateusuario() {
            axios
                .post("api/update-usuario", this.usuario)
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteusuario() {
            axios
                .post("api/delete-usuario", {
                    id: this.usuario.id,
                })
                .then(
                    (res) => {
                        this.$router.push("lista-usuario");
                    },
                    (res) => {}
                );
        },

        saveagente() {
            axios
                .post("api/save-agente", {
                    usuario: this.usuario,
                })
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error(error.response.data.message);
                    }
                });
        },

        save(date) {
            this.$refs.menu.save(date);
        },
    },
    filters: {},
    components: {
        DatosPersonales,
        DeleteDialog,
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
    },
};
</script>
